import {motion} from 'framer-motion'

const ContactSend = () =>{
    return(
        <motion.div 
        exit={{opacity: 0}}
        transition={{duration: .5}}
        >
            <motion.div className="letter-send-opening"
            exit={{opacity: 0}}
            transition={{duration: .75}}
            ></motion.div>
        </motion.div>
    )
}

export default ContactSend;